<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title fw-bold">{{ 'study-editor.plot-visualization-modal.title' | translate}}<span class="badge badge-secondary">BETA</span></h4>
        <button type="button" class="btn-close" (click)="cancel()"></button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-md-12">
                <div class="row mb-2">
                    <span class="col-md-4"><strong>{{'study-editor.plot-visualization-modal.plot-type' | translate}}</strong></span>
                    <div class="col-md-6">
                        <ng-select [(ngModel)]="selectedRCall" (ngModelChange)="selectedRCallChanged()" [searchable]="false" [clearable]="false">
                            <ng-option *ngFor="let item of rCalls" [value]="item">
                                <span>{{ 'study-editor.plot-visualization-modal.plot-type.' + item.description | translate }}</span>
                            </ng-option>
                        </ng-select>
                    </div>
                </div>
                @if (selectedRCall) {
                    @for (item of selectedRCall.parameters | keyvalue; track item.key) {
                        <div class="row">
                            @if (item.key === 'x') {
                                <span class="col-md-4 mb-2"><strong>{{ ((selectedRCall.description == 'Boxplot') ? 'study-editor.plot-visualization-modal.factor-by' : 'study-editor.plot-visualization-modal.variable-on-x') | translate }}
                                    </strong></span>
                            }
                            @if (item.key === 'y') {
                                <span
                                        class="col-md-4 mb-2"><strong>{{ ((selectedRCall.description == 'Boxplot') ? 'study-editor.plot-visualization-modal.variable' : 'study-editor.plot-visualization-modal.variable-on-y') | translate }}
                                    </strong></span>
                            }
                            @if (item.key === 'method') {
                                <span class="col-md-4 mb-2"><strong>{{ 'study-editor.plot-visualization-modal.regression-method' | translate}}</strong></span>
                            }
                            @if (item.key === 'binwidth') {
                                <span class="col-md-4 mb-2"><strong>{{ 'study-editor.plot-visualization-modal.bin-width' | translate }}</strong></span>
                            }
                            <div class="col-md-6">
                                <!-- Scatterplot -->
                                <ng-select *ngIf="(item.key == 'method')" class="mb-2"
                                           [(ngModel)]="selectedRCall.parameters[item.key]"
                                           [searchable]="false" required>
                                    <ng-option *ngFor="let item of regressionMethods" [value]="item.method">
                                        <span>{{ item.description | translate }}</span>
                                    </ng-option>
                                </ng-select>
                                <ng-select *ngIf="item.key == 'x' && selectedRCall.description == 'Scatterplot'" class="mb-2"
                                           [(ngModel)]="selectedVariableX" [searchable]="false" required>
                                    <ng-option *ngFor="let variate of variates" [value]="variate">
                                        <span>{{ variate.alias }}</span>
                                    </ng-option>
                                </ng-select>
                                <ng-select *ngIf="item.key == 'y' && selectedRCall.description == 'Scatterplot'" class="mb-2"
                                           [(ngModel)]="selectedVariableY" [searchable]="false" required>
                                    <ng-option *ngFor="let variate of variates" [value]="variate">
                                        <span>{{ variate.alias }}</span>
                                    </ng-option>
                                </ng-select>
                                <input class="form-control mb-2" type="number" *ngIf="item.key == 'binwidth'"
                                       [(ngModel)]="selectedRCall.parameters[item.key]">
                                <!-- Histogram -->
                                <ng-select *ngIf="item.key == 'x' && selectedRCall.description == 'Histogram'" class="mb-2"
                                           [(ngModel)]="selectedVariableX" [searchable]="false" required>
                                    <ng-option *ngFor="let variate of variates" [value]="variate">
                                        <span>{{ variate.alias }}</span>
                                    </ng-option>
                                </ng-select>
                                <!-- Boxplot -->
                                <ng-select *ngIf="item.key == 'x' && selectedRCall.description == 'Boxplot'" class="mb-2"
                                           [(ngModel)]="selectedVariableX" [searchable]="false" required>
                                    <ng-option *ngFor="let factor of factors" [value]="factor">
                                        <span>{{ factor.alias }}</span>
                                    </ng-option>
                                </ng-select>
                                <ng-select *ngIf="(item.key == 'y') && selectedRCall.description == 'Boxplot'" class="mb-2"
                                           [(ngModel)]="selectedVariableY" [searchable]="false" required>
                                    <ng-option *ngFor="let variate of variates" [value]="variate">
                                        <span>{{ variate.alias }}</span>
                                    </ng-option>
                                </ng-select>
                            </div>
                        </div>
                    }
                }
            </div>
        </div>
    </div>
    <div class="modal-footer">
            <div class="col-md-12 d-flex justify-content-between align-items-center">
                <div class="justify-content-start">
                    Powered by <span style="background-color: #333; padding: 5px; border-radius: 5px"><img src="/Fieldbook/static/img/opencpulogo.png"/></span>
                </div>
                <div class="d-inline-flex">
                    <button class="btn btn-secondary" (click)="cancel()"> {{ 'cancel' | translate}}</button>
                    <button class="btn btn-primary ms-2" [disabled]="isExporting" (click)="generate()"> {{ 'study-editor.plot-visualization-modal.generate' | translate }} </button>
                </div>
            </div>
        </div>
</div>


